import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    fetchAllBlogs, fetchRecentBlogs, searchBlogs,
    fetchBlogPageSeo, fetchBlogBanner
} from "../Adapter/PageAdapter";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import BannerImg from "../assets/images/Blogs.jpg";
import SearchBlk from "../assets/images/spciallites/searchblk.png";

const Blogs = () => {
    const [bannerData, setBannerData] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [visibleBlogs, setVisibleBlogs] = useState(10);
    const [recentBlogs, setRecentBlogs] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const loadSeo = async () => {
            try {
                console.log("Calling fetchBlogPageSeo...");
                const res = await fetchBlogPageSeo();
                console.log("API Response:", res);
                if (res && res.data) {
                    setSeoData(res.data);
                }
            } catch (e) {
                console.error("Direct SEO fetch failed:", e);
            }
        };

        loadSeo();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const bannerResponse = await fetchBlogBanner();
            if (bannerResponse && bannerResponse.data) {
                setBannerData(bannerResponse.data);
            }
        };

        fetchData();
    }, []);

    // const seoData = useSeo(fetchBlogPageSeo);

    // Detect screen size for mobile
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch all blogs and recent blogs on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const blogsResponse = await fetchAllBlogs();
                if (blogsResponse && blogsResponse.data) {
                    setBlogs(blogsResponse.data);
                }

                const recentResponse = await fetchRecentBlogs();
                if (recentResponse && recentResponse.data) {
                    setRecentBlogs(recentResponse.data);
                }
            } catch (error) {
                console.error("Error fetching blogs data:", error);
            }
        };

        fetchData();
    }, []);

    // Handle search functionality
    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchInput.trim()) return;

        try {
            const searchResponse = await searchBlogs({ title: searchInput.trim() });
            if (searchResponse && searchResponse.data) {
                setBlogs(searchResponse.data);
            } else {
                setBlogs([]);
            }
        } catch (error) {
            console.error("Error searching blogs:", error);
        }
    };

    const handleReadMore = (slug) => {
        navigate(`/blogs/${slug}`);
    };

    const loadMoreBlogs = () => {
        setVisibleBlogs((prev) => prev + 10);
    };

    const displayedBlogs = blogs.slice(0, visibleBlogs);
    const displayedRecent = isMobile ? recentBlogs.slice(0, 2) : recentBlogs.slice(0, 10);

    return (
        <>

            {/* {seoData && <SeoHelmet seoData={seoData} />} */}
            {seoData && (
                <Helmet>
                    <title>{seoData.seo_title}</title>
                    <meta name="title" content={seoData.meta_title} />
                    <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
                    <meta name="keywords" content={seoData.meta_keywords} />

                    <meta property="og:title" content={seoData.og_title} />
                    <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
                    <meta property="og:type" content={seoData.og_type} />
                    <meta property="og:url" content={seoData.og_url} />
                    <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
                    <meta property="og:locale" content={seoData.og_locale} />
                    <meta property="og:site_name" content={seoData.og_site_name} />
                    <meta property="article:modified_time" content={seoData.article_modified_time} />

                    <meta name="twitter:card" content={seoData.twitter_card} />
                    <meta name="twitter:title" content={seoData.twitter_title} />
                    <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
                    <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
                    <meta name="twitter:site" content={seoData.twitter_site} />

                    <link rel="canonical" href={seoData.canonical_link} />

                    {/* Custom scripts injection */}
                    {seoData.custom_scripts && (
                        <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
                    )}
                </Helmet>
            )}

            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData[0]?.img_path ? (
                            <img
                                src={`${baseImage_path}${bannerData[0].img_path.replace('.', '')}`}
                                alt={bannerData[0].banner_heading || "Blogs"}
                            />
                        ) : (
                            <img src={BannerImg} alt="Blogs" />
                        )}
                        <div className="ban-con">
                            <h1>{bannerData[0]?.banner_heading || 'Blogs'}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/*  */}
            <section className="our-video-sec mrgntop70 margnbot90">
                {/* <div className="cust-container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-4">
                            <div className="row">
                                {blogs.map((blog) => (
                                    <div
                                        key={blog.id}
                                        className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4"
                                    >
                                        <div className="our-video-sec-item">
                                            <div className="our-video-img">
                                                <img
                                                    src={`${baseImage_path}/${blog.featured_img || "default-blog.jpg"}`}
                                                    alt={blog.title}
                                                />
                                                <div className="our-vdo-categ">
                                                    <span>{blog.category || "Uncategorized"}</span>
                                                </div>
                                            </div>
                                            <div className="our-video-desc our-vdo-desc-cta-green">
                                                
                                                <span>{new Date(blog.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</span><br />
                                                <a href="#" onClick={() => handleReadMore(blog.slug)}>{blog.title}</a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-4">
                            <div className="blog-right-panel">
                                <div className="specialty-search width100">
                                    <form className="example" onSubmit={handleSearch}>
                                        <input
                                            type="text"
                                            placeholder="Search by Title"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                        />
                                        <button type="submit">
                                            <img src={SearchBlk} alt="Search" />
                                        </button>
                                    </form>
                                </div>

                                <div className="blog-recent-items">
                                    <h5>Recent Posts</h5>
                                    {recentBlogs.slice(0, 10).map((post) => (
                                        <div key={post.id} className="our-video-sec-item blog-rece-item">
                                            <div className="our-video-img">
                                                <img
                                                    src={`${baseImage_path}/${post.featured_img || "default-blog.jpg"}`}
                                                    alt={post.title}
                                                />
                                            </div>
                                            <div className="our-video-desc our-vdo-desc-cta-green">
                                                <a href="#" onClick={() => handleReadMore(post.slug)}>{post.title}</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="cust-container">
                    <div className="row">
                        {isMobile && (
                            <div className="col-12 mb-4">
                                <div className="specialty-search width100 mb-3">
                                    <form className="example" onSubmit={handleSearch}>
                                        <input
                                            type="text"
                                            placeholder="Search by Title"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                        />
                                        <button type="submit">
                                            <img src={SearchBlk} alt="Search" />
                                        </button>
                                    </form>
                                </div>

                                <div className="blog-recent-items">
                                    <h5>Recent Posts</h5>
                                    {displayedRecent.map((post) => (
                                        <div key={post.id} className="our-video-sec-item blog-rece-item">
                                            <div className="our-video-img">
                                                <img
                                                    src={`${baseImage_path}/${post.featured_img || "default-blog.jpg"}`}
                                                    alt={post.title}
                                                />
                                            </div>
                                            <div className="our-video-desc our-vdo-desc-cta-green">
                                                <a href="#" onClick={() => handleReadMore(post.slug)}>{post.title}</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-4">
                            <div className="row">
                                {displayedBlogs.map((blog) => (
                                    <div
                                        key={blog.id}
                                        className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-4"
                                    >
                                        <div className="our-video-sec-item">
                                            <div className="our-video-img">
                                                <img
                                                    src={`${baseImage_path}/${blog.featured_img || "default-blog.jpg"}`}
                                                    alt={blog.title}
                                                />
                                                <div className="our-vdo-categ">
                                                    <span>{blog.category || "Uncategorized"}</span>
                                                </div>
                                            </div>
                                            <div className="our-video-desc our-vdo-desc-cta-green">
                                                <span>{new Date(blog.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</span><br />
                                                <a href="#" onClick={() => handleReadMore(blog.slug)}>{blog.title}</a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {visibleBlogs < blogs.length && (
                                <div className="text-center mt-4">
                                    <button className="btn btn-primary" style={{ background: '#00a651' }} onClick={loadMoreBlogs}>Load More</button>
                                </div>
                            )}
                        </div>

                        {!isMobile && (
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-4">
                                <div className="blog-right-panel">
                                    <div className="specialty-search width100">
                                        <form className="example" onSubmit={handleSearch}>
                                            <input
                                                type="text"
                                                placeholder="Search by Title"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                            <button type="submit">
                                                <img src={SearchBlk} alt="Search" />
                                            </button>
                                        </form>
                                    </div>

                                    <div className="blog-recent-items">
                                        <h5>Recent Posts</h5>
                                        {displayedRecent.map((post) => (
                                            <div key={post.id} className="our-video-sec-item blog-rece-item">
                                                <div className="our-video-img">
                                                    <img
                                                        src={`${baseImage_path}/${post.featured_img || "default-blog.jpg"}`}
                                                        alt={post.title}
                                                    />
                                                </div>
                                                <div className="our-video-desc our-vdo-desc-cta-green">
                                                    <a href="#" onClick={() => handleReadMore(post.slug)}>{post.title}</a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Blogs;